import SharedLayout from './layout/SharedLayout'
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import Home from "./pages/Home"
import Detail from "./pages/Detail"
import "./styles/config.scss"
import GDPR from './sections/GDPR'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          {/* Hlavní stránka - všechny sekce */}
          <Route index element={<Home />} />
          
          {/* Jednotlivé sekce - stejná komponenta, ale s automatickým scrollem */}
          <Route path="domu" element={<Home targetSection="domu" />} />
          <Route path="sluzby" element={<Home targetSection="sluzby" />} />
          <Route path="organizace" element={<Home targetSection="organizace" />} />
          <Route path="cenik" element={<Home targetSection="cenik" />} />
          <Route path="kontakt" element={<Home targetSection="kontakt" />} />
          <Route path="recenze" element={<Home targetSection="recenze" />} />

          {/* GDPR stránka - samostatná stránka */}
          <Route path="gdpr" element={<GDPR />} />
          
          {/* Detail stránky */}
          <Route path="detail/:id" element={<Detail />} />
          
          {/* 404 - přesměruj na hlavní stránku */}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App